const ROOT_SELECTOR = '[data-product-share-root]';

const copyText = async (value) => {
  if (navigator.clipboard?.writeText) return navigator.clipboard.writeText(value);
  const field = document.createElement('textarea');
  field.value = value;
  field.setAttribute('readonly', '');
  field.style.position = 'fixed';
  field.style.opacity = '0';
  document.body.append(field);
  field.select();
  document.execCommand('copy');
  field.remove();
};

const initShare = (root) => {
  if (root.dataset.productShareReady === 'true') return;
  root.dataset.productShareReady = 'true';
  const toggle = root.querySelector('[data-product-share]');
  const popover = root.querySelector('[data-product-share-popover]');
  const copy = root.querySelector('[data-product-share-copy]');
  const field = root.querySelector('[data-product-share-url]');
  const status = root.querySelector('[data-product-share-status]');
  if (!toggle || !popover) return;

  const close = () => {
    popover.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (copy) copy.textContent = 'Sao chép';
    if (status) status.textContent = '';
  };
  const open = () => {
    popover.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
  };
  toggle.addEventListener('click', () => (popover.hidden ? open() : close()));
  copy?.addEventListener('click', async () => {
    try {
      await copyText(field?.dataset.copyUrl || field?.value || window.location.href);
      copy.textContent = 'Đã chép ✓';
      if (status) status.textContent = 'Đã sao chép liên kết sản phẩm.';
    } catch {
      field?.focus();
      field?.select();
      if (status) status.textContent = 'Không thể tự động sao chép. Hãy sao chép liên kết trong ô.';
    }
  });
  root.querySelectorAll('[data-product-share-destination]').forEach((link) => link.addEventListener('click', close));
  document.addEventListener('click', (event) => {
    if (!popover.hidden && !root.contains(event.target)) close();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || popover.hidden) return;
    close();
    toggle.focus();
  });
};

const initAll = (scope = document) => scope.querySelectorAll(ROOT_SELECTOR).forEach(initShare);
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
}
